<template>
  <Popover
    :bs="{
      py: 9,
      px: 12,
      border: variant === 'outline' ? '1px solid #3a64ff' : null,
      'cmp.tooltip': 'base',
      'cmp.tooltip.stateless': variant,
      ...bs
    }"
    trigger="hover"
    :arrow-bs="{
      '&:before': {
        bg: variant === 'fill' ? '#444549' : 'white',
        border: variant === 'outline' ? '1px solid #3a64ff' : null,
      }
    }"
    :hidden="!$slots.content && !content"
    v-bind="$attrs"
  >
    <template #default="{ isShownState }">
      <!-- @slot 控制器的插槽 -->
      <slot :isShownState="isShownState" />
    </template>

    <template #popover>
      <template v-if="$slots.content">
        <!-- @slot 在需要传递非文字复杂 content 使用，在 content props 未传递生效 -->
        <slot name="content" />
      </template>
      <Paragraph
        v-else
        :content="content"
        :bs="{
          'cmp.tooltip': 'textContent',
          bg: variant === 'fill' ? '#444549' : 'white',
          borderRadius: variant === 'outline' ? 'control' : null,
          ...tipBs,
        }"
      />
    </template>
  </Popover>
</template>

<script lang="ts">
  import { defineComponent, PropType } from 'vue'
  import Paragraph from '@xhs/yam-beer/cmp/common/Text/Paragraph.vue'
  import Popover from '../Popover/Popover.vue'
  import { BeerStyleObj } from '../../../core'
  import initStyle from './style.js'

  type variant = 'default' | 'outline' | 'fill'

  initStyle()

  /**
   * 提示组件
   * @see 继承Popover /beer-next/ui-blocks/overlayers/popover-doc
   */
  export default defineComponent({
    name: 'Tooltip',
    components: {
      Popover,
      Paragraph,
    },
    props: {
      /**
       * @ignore
       * 弹出浮层的样式
       */
      bs: {
        type: Object as PropType<BeerStyleObj>,
        default: () => ({}),
      },
      /**
       * @ignore
       * 提示的样式
       */
      tipBs: {
        type: Object as PropType<BeerStyleObj>,
        default: () => ({}),
      },
      /**
       * 浮层的不同样式风格 default | outline | fill
       * @type {default|outline|fill}
       */
      variant: {
        type: String as PropType<variant>,
        default: 'default',
      },
      /**
       * 提示的文字内容
       */
      content: {
        type: [String, Array],
        default: undefined,
        required: false,
      },
    },
  })
</script>
